"use client";
import { GET_NAVBAR_QUERYResult } from "@/sanity/sanity.types";
import { useParams } from "next/navigation";

type NavItems = NonNullable<
  NonNullable<GET_NAVBAR_QUERYResult>["mainNav"]
>["items"];

const useFindTranslation = (items: NavItems | undefined | null) => {
  const params = useParams();
  const currentSlug = Array.isArray(params?.slug)
    ? params.slug.join("/")
    : params?.slug;
  const currentLang = params?.lang as "en" | "sv";
  const targetLang = currentLang === "en" ? "sv" : "en";

  // Early return if no items
  if (!items || !currentSlug) {
    return { en: undefined, sv: undefined };
  }

  // Find current item by matching slug
  const currentItem = items.find((item) => {
    const itemSlug = item.link?.slug?.current;
    const hasDirectMatch = itemSlug === currentSlug;
    const hasTranslationMatch = item.link?._translations?.some(
      (t) => t?.slug?.current === currentSlug
    );
    return hasDirectMatch || hasTranslationMatch;
  });

  // No matching item found
  if (!currentItem?.link) {
    return { en: undefined, sv: undefined };
  }

  // Get translation slug
  const translation = currentItem.link._translations?.find(
    (t) => t?.language === targetLang
  );

  // Return slugs for both languages
  const baseSlug = currentItem.link.slug?.current;
  const translatedSlug = translation?.slug?.current;

  return {
    [currentLang]: baseSlug,
    [targetLang]: translatedSlug,
  } as { en: string | undefined; sv: string | undefined };
};

export default useFindTranslation;
